// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel, ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";

const productsUrl = "/api/guest/newslistings";

export interface GetNewsListApiParameter extends ApiParameter {
    page?: number;
    pageSize?: number;
    categories?: string;
}

export interface NewsListApiResult extends BaseModel {
    author: string;
    cardCategory: string;
    cardImage: string;
    cardSummary: string;
    date: string;
    title: string;
    url: string;
    id: string;
}

export interface NewsListCollectionApiResult extends BaseModel {
    id: string;
    categoryCounts: any;
    newsListings: NewsListApiResult[];
    paginationModel: PaginationModel;
}

export interface GetNewsListApiResult {
    successful: boolean;
    errorMessage?: string;
    result?: NewsListCollectionApiResult;
}

export async function getNewsList(
    parameter: GetNewsListApiParameter,
): Promise<GetNewsListApiResult> {
    try {
        const newsLists = await get<NewsListCollectionApiResult>(productsUrl, parameter);
        newsLists.id = `${parameter.categories}-${parameter.page}-${parameter.pageSize}`;
        newsLists.newsListings.forEach(newsList => {newsList.id = `${newsList.cardCategory}-${newsList.title}-${parameter.page}-${parameter.pageSize}`});
        return {
            successful: true,
            result: newsLists,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
